import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalGuardConfiguration } from '@azure/msal-angular';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

export const msalAuthConfig = {
  clientId: environment.msal.clientId,
  authority: `https://${environment.msal.tenantId}.ciamlogin.com/${environment.msal.tenantId}`,
  knownAuthorities: [`${environment.msal.tenantId}.ciamlogin.com`],
};

export function MSALInstanceFactory(): IPublicClientApplication {
  const isNative = Capacitor.isNativePlatform();
  const nativeRedirectUri =
    Capacitor.getPlatform() === 'android'
      ? environment.msal.androidNativeRedirectUri
      : environment.msal.nativeRedirectUri;

  return new PublicClientApplication({
    auth: {
      clientId: environment.msal.clientId,
      authority: `https://${environment.msal.tenantId}.ciamlogin.com/${environment.msal.tenantId}`,
      knownAuthorities: [`${environment.msal.tenantId}.ciamlogin.com`],
      redirectUri: isNative
        ? nativeRedirectUri
        : window.location.origin,
      onRedirectNavigate: isNative
        ? (url: string) => {
            Browser.open({ url });
            return false;
          }
        : undefined,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback: (_level, message, containsPii) => {
          if (containsPii) return;
          if (!environment.production) console.log(`MSAL Config - ${message}`);
        },
        logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: { scopes: environment.msal.scopes },
    loginFailedRoute: '/login',
  };
}
